export function menuBadgeCount(store, getterName) {
    if (!getterName || !store || !(getterName in store.getters)) {
        return 0
    }
    const value = Number(store.getters[getterName])
    return Number.isFinite(value) && value > 0 ? value : 0
}

export function menuBadgeText(count) {
    if (count > 99) {
        return '99+'
    }
    return String(count)
}
